import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { purchasesService } from '../../../services/purchases.service'
import { BatchOptionSelect } from '../../inventory/BatchOptionSelect'

interface PurchaseBatchSelectProps {
  productId?: number
  sucursalId?: number
  value?: number | string
  onChange: (batchId: number | undefined) => void
  disabled?: boolean
  placeholder?: string
}

export function PurchaseBatchSelect({
  productId,
  sucursalId,
  value,
  onChange,
  disabled = false,
  placeholder = 'Selecciona un lote vigente',
}: PurchaseBatchSelectProps) {
  const query = useQuery({
    queryKey: ['purchase-batch-options', productId, sucursalId],
    queryFn: () => purchasesService.getPurchaseBatchOptions(productId!, sucursalId!),
    enabled: Boolean(productId && sucursalId),
  })
  const batches = query.data?.data ?? []
  useEffect(() => {
    onChange(undefined)
    // La selección pertenece estrictamente a la combinación producto/sucursal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, sucursalId])

  return (
    <BatchOptionSelect
      options={batches.map((batch) => ({
        id: batch.id,
        batchNumber: batch.batch_number,
        expirationDate: batch.expiration_date,
        physical: batch.quantity,
      }))}
      value={value}
      onChange={onChange}
      loading={query.isLoading}
      error={query.isError}
      onRetry={() => void query.refetch()}
      disabled={disabled || !productId || !sucursalId}
      placeholder={placeholder}
      emptyHint={productId && sucursalId
        ? 'Captura un lote nuevo; si coincide con uno archivado, se reactivará automáticamente al recibir.'
        : undefined}
    />
  )
}
